<div class="segments-metrics">
  <!-- Metrics Grid -->
  <div class="metrics-grid">
    <div 
      *ngFor="let metric of metrics; trackBy: trackByIndex" 
      class="metric-card"
      [style.background]="metric.gradient">
      <div class="metric-content">
        <div class="metric-info">
          <div class="metric-title">{{ metric.title }}</div>
          <div class="metric-value">{{ metric.value }}</div>
        </div>
        <div class="metric-icon">
            <!-- <img src="/assets/images/appointments-card-bg.png" alt="Campaign Stats Icon" class="stat-icon"> -->
        </div>
      </div>
    </div>
  </div>
</div>
